module.exports = __webpack_public_path__ + "static/media/person-tom-cirrito.55cb8013.png";